import { cn, FormLabel } from '@wellesley/ui'
import { FC } from 'react'

type CmpProps = {
  displayName: string
  isRequired?: boolean
  disabled?: boolean
}

const Label: FC<CmpProps> = ({ isRequired, displayName, disabled }) => {
  return (
    <FormLabel
      isRequired={isRequired}
      className={cn(
        'mb-0 flex items-center gap-1 text-sm font-medium text-gray-900',
        {
          'select-none text-gray-300': disabled,
        },
      )}
    >
      {displayName}
    </FormLabel>
  )
}

export default Label
